import classNames from 'classnames';
import React from 'react';
import styles from './section.module.scss';

interface SectionProps extends React.ComponentPropsWithoutRef<'section'> {
    children: React.ReactNode;
    top?: 'lg' | 'md' | 'sm' | 'none';
    bottom?: 'lg' | 'md' | 'sm' | 'none';
}

const Section = React.forwardRef<HTMLDivElement, SectionProps>(
    ({ children, top = 'lg', bottom = 'lg', ...props }, ref) => {
        return (
            <section
                ref={ref}
                {...props}
                className={classNames([
                    styles.section,
                    top === 'lg' ? styles.ptLarge : '',
                    top === 'md' ? styles.ptMedium : '',
                    top === 'sm' ? styles.ptSmall : '',
                    top === 'none' ? styles.ptNone : '',
                    bottom === 'lg' ? styles.pbLarge : '',
                    bottom === 'md' ? styles.pbMedium : '',
                    bottom === 'sm' ? styles.pbSmall : '',
                    bottom === 'none' ? styles.pbNone : '',
                    props.className,
                ])}
            >
                {children}
            </section>
        );
    }
);

Section.displayName = 'Section';

export default Section;
